<!-- @for(breadcrumb of breadcrumbs; track breadcrumb){
<span class="nav-item">
  <span>Project / </span>
  <a class="nav-link" [routerLink]="breadcrumb.url">{{ breadcrumb.label }} /</a>
  
</span>
} -->

<div class="scaled-125">
  <nav>
    @for(breadcrumb of breadcrumbs; track breadcrumb; let last = $last ){
    <ng-container>
      <!-- @if(!last){
    <span>
      <a
        [href]="
          'https://' + urlDomain + '/ui/#t/0TB000000000733/V2C/' + projectId
        "
        target="_blank"
        class="cursor-pointer previous-route"
        (click)="navigateTo(breadcrumb.url)"
        [matTooltip]="
          breadcrumb.label === projectNameShort ? fullProjectName : ''
        "
        >{{ breadcrumb.label }}</a
      >
      /
    </span>
    }  -->
      @if (!last) {
      <span>
        @if (breadcrumb.label === projectNameShort) {
        <a
          [href]="
            'https://' + urlDomain + '/ui/#t/0TB000000000733/V2C/' + projectId
          "
          target="_blank"
          class="cursor-pointer previous-route"
          [matTooltip]="fullProjectName"
        >
          {{ breadcrumb.label }}
        </a>
        } @else {
        <a
          class="cursor-pointer previous-route"
          (click)="navigateTo(breadcrumb.url)"
          [matTooltip]="
            breadcrumb.label === projectNameShort ? fullProjectName : ''
          "
        >
          {{ breadcrumb.label }}
        </a>
        } /
      </span>
      } @if(last){
      <span>
        <a
          class="cursor-pointer current-route"
          (click)="navigateTo(breadcrumb.url)"
          >{{ breadcrumb.label }}</a
        >
      </span>
      }
    </ng-container>
    }
  </nav>
</div>
